module.exports = __webpack_public_path__ + "img/zuhe4.579b0103.png";